import React from 'react';
import PropTypes from 'prop-types';

import MuiLink from '@material-ui/core/Link';

/**
 * Default Link component based on https://material-ui.com/components/links/
 * @param {} props All possible props can be found in docs https://material-ui.com/api/Link/
 */
export default function Link(props) {
  const { children, href, ...rest } = props;

  return (
    <MuiLink
      href={href}
      classes={{ root: { color: props.color ? props.color : 'default' } }}
      color="inherit"
      underline="none"
      {...rest}
    >
      {children}
    </MuiLink>
  );
}

Link.propTypes = {
  /**
   * Link name.
   */
  children: PropTypes.node,
  /**
   * Link URL.
   */
  href: PropTypes.string,
};
